import React, { FC, useCallback } from 'react'
import { FileRowProps } from '../../Abbreviations/tableRow/types'
import TableCell from '../../../../../uiKit/table/TableCell'
import { notAllowToSaveChangesForSingleInput } from '../../Abbreviations/tableRow/configs'
import { TableRowRemoveElement } from '../../tableRowRemove'
import TableRow from 'uiKit/table/TableRow'
import { fileTableConfig } from './config/configs'
import { DynamicTextAndInput } from '../../Abbreviations/tableRow/dynamicTextInput'
import { DescriptionTableRowCell } from './DescriptionTableRowCell'
import { DownloadFileButton } from './button/DownloadFileButton'
import { knowledgeFileService } from '../../../api/knowledgeFile'
import { saveAs } from 'file-saver'
import { DownloadFileRequestDto } from '../types/knowledge-types'

export const FileTableRow: FC<FileRowProps> = ({
  sources,
  index,
  onDelete,
  updateSource,
  isDownloadEnabled,
  onBlurHandle,
  textNotEditable,
}) => {
  const onDeleteButtonPressed = useCallback(() => {
    onDelete(sources._id)
  }, [sources._id])

  const handleDownload = () => {
    knowledgeFileService
      .downloadKnowledgeFile(sources._id, makeRequest(sources))
      .then(blob => saveAs(blob, sources.originalFilename))
  }

  const makeRequest = (source: any): DownloadFileRequestDto => {
    return {
      originalFilename: source.originalFilename,
      storageDetails: source.storageDetails
    }
  }

  return (
    <TableRow key={index} index={index} style={{}}>
      <TableCell style={fileTableConfig.name}>
        <DynamicTextAndInput
          value={sources.originalFilename}
          inputValidation={notAllowToSaveChangesForSingleInput}
          textNotEditable={textNotEditable}
        />
      </TableCell>
      <TableCell style={fileTableConfig.description}>
        <DescriptionTableRowCell source={sources} updateSource={updateSource} onBlurHandle={onBlurHandle} />
      </TableCell>
      <TableCell style={fileTableConfig.removeButton}>
        <TableRowRemoveElement
          removeAction={onDeleteButtonPressed}
          title={'Remove knowledge file?'}
          content={'Are you sure that you want to delete knowledge file?'}
        />
        {isDownloadEnabled && <DownloadFileButton onUpload={handleDownload} />}
      </TableCell>
    </TableRow>
  )
}
